/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.getCrmFields.internal

import features.getCrmFields.models.CrmFields
import kangaroorewards.appsdk.core.io.IOResult
import kangaroorewards.appsdk.core.network.NetworkRequest

internal class GetCrmFieldsRequest : NetworkRequest() {

    suspend fun getCrmFields(
        overrideHeaders: Map<String, String>? = null,

    ): IOResult<CrmFields> {
        return safeNetworkCall {
            get(
                endpoint = GetCrmFieldsEndpoint,
                serverHostId = 0,
                overrideHeaders = overrideHeaders
            )
        }
    }
}
